import React, { useEffect } from "react";
import apnagharLogo from "./apnaghar.png";
import "./WhyChooseUs.css";

const features = [
  { icon: "🛡️", title: "100% Verified Properties", text: "We manually check every listing to keep scams away." },
  { icon: "💸", title: "Zero Brokerage", text: "No middlemen. No commission. You save money every time." },
  { icon: "⚡", title: "Fast & Modern Platform", text: "Optimized to load fast even on slow networks." },
  { icon: "📍", title: "Location-Based Matching", text: "Instantly discover homes near colleges & workplaces." },
  { icon: "🤝", title: "Trusted by Thousands", text: "Students, families & professionals rely on us daily." },
  { icon: "🔔", title: "Smart Alerts", text: "Get notified instantly when new properties match your needs." }
];

const WhyChooseUs = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect(); // cleanup
  }, []);

  return (
    <section className="wcu-section">
      <div className="wcu-wrapper">

        <h2 className="wcu-title reveal">
          Why Choose <span>ApkaGhr?</span>
        </h2>

        <p className="wcu-subtitle reveal">
          Transparent • Secure • Modern<br />
          Your trusted partner for PGs & Rentals in Assam.
        </p>

        <div className="wcu-cards">
          {features.map((item, i) => (
            <div className="wcu-card reveal" key={i}>
              <div className="wcu-icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>

        <div className="wcu-footer-card reveal">
          <div className="footer-left">
            <img
              src={apnagharLogo}
              alt="ApkaGhr Logo"
              className="footer-logo"
              loading="eager"
            />
            <span className="footer-text">ApkaGhr</span>
          </div>

          <div className="footer-marquee">
            <p>
              Discover homes • List your property • Zero Brokerage • Fast & Modern Platform • Trusted by Thousands
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
